export default __webpack_public_path__ + "static/media/navBannerImg0.f937d543.png";